import { render, staticRenderFns } from "./RenameDepartmentDialog.vue?vue&type=template&id=123d26e6"
import script from "./RenameDepartmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameDepartmentDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports